module.exports = __webpack_public_path__ + "assets/img/defultPreviewFileM.f56cb50c.png";